<template>
  <section class="programs">
    <Container>
      <Title tag="h2">Programas de investigación</Title>
      <Row>
        <ColumnUi md="6" lg="4" class="program">
          <div class="icon-wrapper">
            <Icon svg="folder" class="program__icon" />
          </div>
          <div class="program__info">
            <h3 class="program__title">Ciencias de la tierra sólida</h3>
            <span
              ><Button
                tag="a"
                href="http://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-tierra-solida/"
                target="_blank"
                theme="primary"
                >Conoce más</Button
              ></span
            >
          </div>
        </ColumnUi>
        <ColumnUi md="6" lg="4" class="program">
          <div class="icon-wrapper">
            <Icon svg="folder" class="program__icon" />
          </div>
          <div class="program__info">
            <h3 class="program__title">
              Ciencias de la Atmósfera, Hidrosfera y Cambio Climático
            </h3>
            <span
              ><Button
                tag="a"
                href="http://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/"
                target="_blank"
                theme="primary"
                >Conoce más</Button
              ></span
            >
          </div>
        </ColumnUi>
        <ColumnUi md="6" lg="4" class="program">
          <div class="icon-wrapper">
            <Icon svg="folder" class="program__icon" />
          </div>
          <div class="program__info">
            <h3 class="program__title">Ciencias del Geoespacio</h3>
            <span
              ><Button
                tag="a"
                href="http://www.igp.gob.pe/programas-de-investigacion/ciencias-del-geoespacio-y-astronomia/"
                target="_blank"
                theme="primary"
                >Conoce más</Button
              ></span
            >
          </div>
        </ColumnUi>
      </Row>
    </Container>
  </section>
</template>
<script>
import Container from "@/components/ui/objects/Container";
import Button from "@/components/ui/atoms/Button";
import Icon from "@/components/ui/atoms/Icon";
import Row from "../ui/atoms/Row.vue";
import ColumnUi from "../ui/atoms/ColumnUi.vue";
import Title from "../ui/atoms/Title.vue";
export default {
  components: {
    Container,
    Button,
    Icon,
    Row,
    ColumnUi,
    Title,
  },
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
@use "@/assets/styles/tools/_mixins.scss";
.programs {
  padding: variables.$spacing-l 0;
  background: variables.$background-light-color;
}
.program {
  display: flex;
  align-items: center;
  grid-gap: 0 1.5em;
  margin-bottom: 2em;
  .icon-wrapper {
    min-width: 100px;
    height: 100px;
    background-color: variables.$primary-color;
    border-radius: 50%;
    @include mixins.centered;
  }
  &__title {
    text-transform: uppercase;
  }
  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &__icon {
    height: 3em;
    fill: variables.$text-inverted-color;
    margin: 0;
  }
}
@media (min-width: variables.$lg) {
  .program {
    margin-bottom: 0;
  }
}
</style>
